import { render, staticRenderFns } from "./feedback-form.vue?vue&type=template&id=e56ece9c&scoped=true"
import script from "./feedback-form.vue?vue&type=script&lang=js"
export * from "./feedback-form.vue?vue&type=script&lang=js"
import style0 from "./feedback-form.vue?vue&type=style&index=0&id=e56ece9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56ece9c",
  null
  
)

export default component.exports